import { useEffect, useState } from 'react'
import getFontProperties from 'utils/getFontProperties'

import themeStyles from 'assets/styles/theme.module.sass'

const { horizontalSpacing, verticalSpacing } = themeStyles

export const getThemeVariable = (themeValue) => {
	let computedThemeValue = themeValue
	if (`${themeValue}`.match(/^var\((--.*?)(,.*)?\)$/)) {
		const [, varName, defaultValue] = `${themeValue}`.match(
			/^var\((--.*?)(,.*)?\)$/
		)
		computedThemeValue =
			getComputedStyle(document.documentElement).getPropertyValue(
				varName
			) || defaultValue.replace(/^, ?/, '')
	}
	return parseFloat(computedThemeValue)
}

export const getThemeSpacing = () => [
	getThemeVariable(verticalSpacing),
	getThemeVariable(horizontalSpacing),
]

const useCollectionSpecs = (
	collectionElem,
	rect,
	themeHorizontalSpacing,
	fontSizeAdjustment = 1
) => {
	const [textSpecs, setTextSpecs] = useState({})

	useEffect(() => {
		if (!collectionElem || !collectionElem.current || !rect) return

		const style = getComputedStyle(collectionElem.current)
		const { fontSize, fontWeight, fontFamily, lineHeight, letterSpacing } =
			getFontProperties(style)
		const maxWidth = rect.width

		const fontSizeMultiplied = fontSize * fontSizeAdjustment
		const lineHeightMultiplied = lineHeight * fontSizeAdjustment
		const letterSpacingMultiplied = letterSpacing * fontSizeAdjustment

		setTextSpecs((prev) => {
			if (maxWidth) {
				return {
					fontSize: fontSizeMultiplied,
					fontWeight,
					fontFamily,
					letterSpacing: letterSpacingMultiplied,
					lineHeight: lineHeightMultiplied,
					maxWidth: maxWidth - themeHorizontalSpacing,
				}
			}
			return prev
		})

		//eslint-disable-next-line
	}, [rect, collectionElem])

	return textSpecs
}

export default useCollectionSpecs
